export default __webpack_public_path__ + "static/media/redirect_icon.51db91a5.svg";